import { get } from 'utils/request';
import { GET_TEXTS } from './constants';

export const loadTexts = () => ({
    type: GET_TEXTS,
    payload: get('/api/texts'),
});
